import React, { useEffect } from "react";
import Routes from "./routes/index";
import { BrowserRouter as Router, useLocation, useHistory } from "react-router-dom";
import routers from "routes/routes";
import "./assets/css/style.css";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const location = useLocation();
  const path = location.pathname;

  const history = useHistory();

  useEffect(() => {
    const [, first, second, third] = path.split("/");

    const found = routers.some((route) =>
      route.childrens?.some((child) => {
        if (route.path.toLowerCase() === `/${first}`.toLowerCase()) {
          if (path.split("/").length > 2) {
            return `${route.path}${child.path}`.toLowerCase() === path.toLowerCase();
          }
          return true;
        }
        return path === "/";
      })
    );

    const refreshPage = () => window.location.reload(false);

    const isPredictorOrNeet = ["neet-college-predictor", "neet-ug"].includes(first);
    const isDashboard = path === "/dashboard" || path === "/dashboard/";
    const isPortal = path === "/portal" || path === "/portal/";
    const isOldVideos = first === "videos" && second === "play";

    // Whenever we are creating a route with slug we need to include the pathname here in the array to avoid getting redirected to 404 page.
    const isSpecialCase =
      (["institutes", "blogs", "videos"].includes(first) && second) ||
      (first === "portal" && second === "videos" && third) ||
      (first === "portal" && ["institutes", "counsellings", "universities"].includes(second));

    if (!found) {
      if (isPredictorOrNeet) {
        window.open("https://zynerd.com/", "_self");
      } else if (isDashboard) {
        window.open("/portal/dashboard", "_self");
      } else if (isOldVideos) {
        const params = new URLSearchParams(location.search);
        const videoId = params.get("v");
        window.open(`/portal/videos/${videoId}`, "_self");
      } else if (isSpecialCase) {
        return;
      } else {
        history.push("/error/page-not-found");
        refreshPage();
      }
    } else if (isPortal) {
      window.open("/portal/dashboard", "_self");
    }
  }, [path, history]);

  return <Routes />;
}

function Main() {
  return (
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  );
}

export default Main;
